import { render, staticRenderFns } from "./TabWaitingApproval.vue?vue&type=template&id=49444fe0"
import script from "./TabWaitingApproval.vue?vue&type=script&lang=js"
export * from "./TabWaitingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports